import React, {useEffect, useRef,useState} from "react"

import {Map, FullscreenControl , NavigationControl,ScaleControl} from 'maplibre-gl';
import { Loading } from "carbon-components-react";
import 'maplibre-gl/dist/maplibre-gl.css';

import geoFences from '../../assets/geocercas/geofences.json'

import {getGeofenceCategory} from '../../services/geofences'

import {router,basemapTilesSource, getPopupHtml} from '../../services/iconRouter'

import { hoverPopup,fixedPopup,geoFencePopup } from "../../services/mapPopups";

import './MapComponent.scss';

const  MapComponent = ({
    startingLat,
    startingLong,
    startingZoom,  
    startingPitch,
    basemap= "OSM",
    trucksData,
    showIcons
}) => {

    const mapContainer = useRef(null);
    const wraperRef = useRef(null)
    const isFixedPopupDisplayed = useRef(false);    
    const map = useRef(null);
    const [hideMap,setHideMap] = useState(true)

    useEffect(()=> {
        
        if (map !== null && map.current !== null && map.current.getLayer('trucks') !== null && map.current.isStyleLoaded()) {
            const target = showIcons ? "visible" : "none"
            map.current.setLayoutProperty('trucks','visibility',target)
            setHideMap(false)
        }
        
    },[showIcons])

    useEffect(()=> {
        if (!map.current || !map.current.loaded()) return

        if (map.current.getSource('trucks') === undefined){
            map.current.addSource('trucks',{
                type:'geojson',
                data: {
                    type: "FeatureCollection",
                    features: trucksData
                }
            })

            if (!map?.current?.getStyle().layers?.map(d => d.id).includes('trucks')){
                map.current.addLayer({
                    id:"trucks",
                    'type': 'symbol',
                    'source': "trucks",
                    'layout': {
                        "text-field": ['get','truckPatent'],
                        'text-font': [
                            'Roboto Bold'
                        ],
                        "text-size": 12,
                        "text-offset":[0,-2.5],
                        "text-overlap":"cooperative",
                        "text-justify": "center",
                        'symbol-placement': 'point',    
                        'icon-image': ['get','icon'],
                        'icon-allow-overlap': true,
                        'icon-overlap':"always",
                        'visibility':"visible"
                        
                    },
                    'paint':{
                        "text-color": ["get","status"]
                    }
                })

                map.current.on('styledata',()=> setHideMap(false))    


            }

        } else {

            const layer = map.current.getSource('trucks')
            layer.setData({
                type: "FeatureCollection",
                features: trucksData
            })

        }
        map.current.redraw()

    },[trucksData])

    const createpopupHandlers = () => {

        map.current.on('mouseenter', 'trucks', (e) => {

            map.current.getCanvas().style.cursor = 'pointer';

            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = getPopupHtml(e.features[0].properties)
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            if (!isFixedPopupDisplayed.current){

                hoverPopup
                    .setLngLat(coordinates)
                    .setHTML(description)
                    .addTo(map.current);
            }
            
        });

        fixedPopup.on('close',()=> {
            isFixedPopupDisplayed.current = false;
        })

        map.current.on('click', 'trucks', (e) => {
            map.current.getCanvas().style.cursor = 'pointer';
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = getPopupHtml(e.features[0].properties);
            

            
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            fixedPopup
                .setLngLat(coordinates)
                .setHTML(description)
                .addClassName('g100')
                .addTo(map.current);
            isFixedPopupDisplayed.current = true
        });
        map.current.on('click', 'geofences', (e) => {
            if (isFixedPopupDisplayed.current) return;
          
            map.current.getCanvas().style.cursor = 'pointer';
          
            const coords = e.features[0]?.geometry?.coordinates;
          
            if (!coords || !coords.length) {
              console.error('No coordinates found.');
              return;
            }
          
            let lngLat;
          
            if (Array.isArray(coords[0][0][0])) {
              // coords[0][0] is an array of many [lng, lat]
              lngLat = coords[0][0][0].slice();
            } else if (Array.isArray(coords[0][0])) {
              // coords[0][0] is a single [lng, lat] pair
              lngLat = coords[0][0].slice();
            } else {
              console.error('Unexpected coordinates structure.', coords);
              return;
            }
          
            if (!Array.isArray(lngLat) || lngLat.length !== 2) {
              console.error('LngLat extracted is invalid.', lngLat);
              return;
            }
          
            while (Math.abs(e.lngLat.lng - lngLat[0]) > 180) {
              lngLat[0] += e.lngLat.lng > lngLat[0] ? 360 : -360;
            }
          
            const description = `
              <div class='geoFencePopupContent'>
                <p style="font-weight: bold; border-bottom: 3px solid orange;"><strong>Nombre: </strong> ${e.features[0].properties.fullName}</p>
                <p><strong>Velocidad Maxima: </strong> ${e.features[0].properties.maxV ?? "No Aplica"}</p>
                <p><strong>Tipo de Geocerca: </strong> ${e.features[0].properties.geofenceType ?? "No Aplica"}</p>
              </div>`;
                    
            geoFencePopup
              .setLngLat(lngLat)
              .setHTML(description)
              .addTo(map.current);
          });                          
    }
    

    const addLayers = async () => {

        addGeoFences()
        addAllIcons()
        createpopupHandlers()
        // Set max bounds
        const bounds = [
            [-69.0, -22.7], // Southwest corner [minLng, minLat]
            [-68.6, -22.2]  // Northeast corner [maxLng, maxLat]
        ];
        map.current.setMaxBounds(bounds);
        // map.current.setMaxBounds(map.current.getBounds())

        map.current.redraw()
    }


    


    const addGeoFences = async () => {

        const withFillColor = {
            type: "FeatureCollection",
            features: geoFences.features.map( (d) => {
                const speedLimitUp = d.properties?.speed_limit_up ?? d.properties?.limite_de_;

                const speedValue = speedLimitUp !== undefined ? Number(speedLimitUp) : 150;
          
                const geofenceCategory = getGeofenceCategory(speedValue);
                                     
                return {
                    ...d,
                    properties: {
                        ...d.properties,
                        fill: geofenceCategory.fill,
                        border:geofenceCategory.border,
                        maxV: d.properties?.speed_limit_up ?? "No Aplica",
                        geofenceType: geofenceCategory.category,
                        fullName: d.properties?.name ?? d.properties?.Name ?? d.properties.nombre_de_ ?? "",
                        
                    }
                }
            })
        }
        

        map.current.addSource('geoFences',{
            type:"geojson",
            data: withFillColor
        })


        map.current.addLayer({
            id:'geofences',
            'type': 'fill',
            'source': 'geoFences',
            'paint': {
                'fill-color': ['get','fill'],
                'fill-opacity':  .8,
                'fill-outline-color': ['get','border']
            },
        })
    }

    

    const addAllIcons = async() => {
        Object.keys(router).forEach((d) => {
            const image = new Image(50,35)
            image.src = router[d]
            try{
                image.onload = () => map.current.addImage(d,image)
            } catch (e) {
                console.log(e)
            }  
        }) 
    }


    useEffect(()=> {
        if (map.current) return;



        map.current = new Map({
            container: mapContainer.current, // container id
            center: [startingLong, startingLat], // starting position [lng, lat]
            zoom: startingZoom, // starting zoom
            pitch: startingPitch,
            style: {
              version: 8,
              sources: {
                  osm: {
                      type: 'raster',
                      // tiles: ['https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'],
                      tiles: [basemapTilesSource[basemap]],
                      tileSize: 256,
                      attribution: '&copy; OpenStreetMap Contributors',
                      maxzoom: 19
                  },                
              },
              layers: [
                  {
                      id: 'osm',
                      type: 'raster',
                      source: 'osm'
                }],
              sky: {
                "sky-color": "#199EF3",
                "sky-horizon-blend": 0.5,
                "horizon-color": "#ffffff",
                "horizon-fog-blend": 0.5,
                "fog-color": "#0000ff",
                "fog-ground-blend": 0.5,
                "atmosphere-blend": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    0,
                    1,
                    10,
                    1,
                    12,
                    0
                ]
              },
              glyphs: "https://fonts.undpgeohub.org/fonts/{fontstack}/{range}.pbf",
              },
          maxZoom: 18,
          maxPitch: 85
        });

        map?.current.addControl(new NavigationControl());
        map?.current.addControl(new FullscreenControl({container: document.querySelector('root')}));
        // map?.current.addControl(new maplibregl.LogoControl({compact: true}));

        // map?.current.addControl(new GeolocateControl({
        //     positionOptions: {
        //         enableHighAccuracy: true
        //     },
        //     trackUserLocation: true
        // }));

        map?.current.addControl(new ScaleControl({
            maxWidth: 200,
            unit: 'metric'
        }));

        // map?.current.addControl(new ColorBlockerControl())

        map.current.on('load',()=> addLayers())
        map.current["dragRotate"].disable()       
        // Set max bounds
        const bounds = [
            [-69.0, -22.7], // Southwest corner [minLng, minLat]
            [-68.6, -22.2]  // Northeast corner [maxLng, maxLat]
        ];
        map.current.setMaxBounds(bounds);
        map.current.setMaxZoom(24)
        map.current.setMinZoom(12)

        map.current.redraw()        
    })

    return (
        <>
            
            <div 
                ref={wraperRef} style={{
                    width:"98%",
                    height:"70vh",
                    padding:"50",
                    marginBottom: "10px"
                    }
                
                }
                    >
                <div ref={mapContainer} style={{
                    width:"100%",
                    height:"100%",
                    padding:"50",
                    }}
                    
                     >
                {hideMap ? <Loading /> : <></> }
                </div>
                
            
                
                
            </div>
            
            
            
        </>
    )
}

export default MapComponent